module.exports = __webpack_public_path__ + "img/loading.4fdf621.gif";